import React, { useEffect, useState } from "react";
import "./Homepage.css";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Dashboard from "../components/Dashboard";
import Footer from "../components/Footer";
import playground from "../assets/img/product_img/Indoor playground.png";
import trampoline from "../assets/img/product_img/Trampoline Park.png";
import interactiveGame from "../assets/img/product_img/Interactive Games.png";
import ClimbingWall from "../assets/img/product_img/Climbing Wall.png";
import ninjapark from "../assets/img/product_img/Ninja Park.png";
import entrancesoftware from "../assets/img/product_img/Entrance Software.png";
import plusicon from "../assets/img/product_img/plusicon.png";
import { Link } from "react-router-dom";
import image1 from "../assets/img/project_img/project_img/image1.png";
import image2 from "../assets/img/project_img/project_img/image2.png";
import image3 from "../assets/img/project_img/project_img/image3.png";
import image4 from "../assets/img/project_img/project_img/image4.png";
import bgframe from "../assets/img/project_img/project_img/bgframe.png";
import OnSiteIcon from "../assets/img/services_img/services_img/onsite.png";
import QualityControlIcon from "../assets/img/services_img/services_img/quality.png";
import SupportIcon from "../assets/img/services_img/services_img/maintanance.png";
import InHouseIcon from "../assets/img/services_img/services_img/inHouse.png";
import BespokeIcon from "../assets/img/services_img/services_img/bespoke.png";
import AllDetailsIcon from "../assets/img/services_img/services_img/allDetails.png";
import GroupLayer from "../assets/img/services_img/services_img/logoupscaled.jpg";
import homeImage from "../assets/img/imagefile/imagefile/homeBannerImg.png";
import AOS from "aos";
import "aos/dist/aos.css";
import CompaniesCard from "./CompaniesCard.jsx";
import { Helmet } from "react-helmet";
import WhatsappButton from "../components/WhatsappButton.jsx";

const Homepage = () => {
  const [expandedCards, setExpandedCards] = useState({});

    const navigate = useNavigate();

  useEffect(() => {
    AOS.init();
  }, []);

    const handleTap = (e) => {
    e.preventDefault();
    navigate("/getquotations");
  };

  let title = (
    <h1>
      GEM – Indoor Playground Manufacturer
      <br /> Crafting Fun Without Limits!
    </h1>
  );

 let description = (
    <>
      <h2 className="dashboard-content">
        Your gateway to the ultimate entertainment experience! As one of the
        leading{" "}
        <Link to="/IndoorPlayground" style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}>
          Indoor Playground Equipment Manufacturers
        </Link>{" "}
        and{" "}
        <Link to="/TrampolinePark" style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}>
          Trampoline Park Manufacturers
        </Link>{" "}
        in the Middle East, GEM delivers world-class innovation
        and fun. We specialize in crafting safe, durable, and imaginative play
        areas that inspire joy for every age group.
        <br />
        <br />
        From being a trusted commercial playground equipment manufacturer to a
        reliable   <Link to="/IndoorPlayground" style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}>
          Indoor Playground Equipment supplier
        </Link>{" "}
        , our products redefine
        recreation spaces with creativity and quality. Choose GEM, one of the
        most trusted playground manufacturers in the region, and bring your dream
        playground to life!
      </h2>
    </>
  );

  const faqData = [
    {
      question: "Do you provide installation services as an Indoor Playground Manufacturer and Trampoline Park Manufacturer?",
      answer: "Yes! GEM, a leading Indoor Playground Manufacturer and Trampoline Park Manufacturer, offers a professional installation team to ensure every product is installed accurately and in full compliance with safety regulations. Our experts handle everything from setup to final inspection, providing a safe and reliable play environment for your venue."
    },
    {
      question: "Does GEM, an Indoor Playground Manufacturer and Trampoline Park Manufacturer, follow safety standards for its playground products?",
      answer: "Absolutely. As a trusted Indoor Playground Manufacturer and Trampoline Park Manufacturer, GEM strictly follows local and international safety standards. All equipment undergoes rigorous testing and certification, and we use environmentally friendly, high-quality materials. Continuous quality control ensures every product meets the highest standards of safety and durability."
    },
    {
      question: "Are custom design services available?",
      answer: "Yes! GEM, a leading Indoor Playground Manufacturer and Trampoline Park expert, provides fully customized design solutions tailored to your space and requirements. Our experienced design team collaborates with you to create unique indoor playground and trampoline park concepts that integrate seamlessly into your venue, maximizing both fun and functionality."
    },
    {
      question: "What age group are GEM products suitable for?",
      answer: "Our play solutions cater to children of all ages from toddlers to teenagers. As a professional Indoor Playground Manufacturer and Trampoline Park Manufacturer, GEM designs equipment that is safe, engaging, and suitable for a wide range of age groups, ensuring fun and development for every visitor."
    },
    {
      question: "What materials does GEM use for playground and trampoline structures as an Indoor Playground Manufacturer and Trampoline Park Manufacturer?",
      answer: "As a certified Indoor Playground Manufacturer and Trampoline Park Manufacturer, GEM uses only high-quality, non-toxic, and eco-friendly materials. Our products include galvanized steel frames, soft padding, and durable plastics that meet or exceed international ASTM and EN safety standards."
    },
    {
      question: "How long does the installation process take with an Indoor Playground Manufacturer like GEM?",
      answer: "The installation timeline depends on the project's size and complexity. As a professional Indoor Playground Manufacturer, GEM ensures fast and precise installation through its skilled technical team. For trampoline parks and larger play zones, our dedicated installers work systematically to complete the setup on time while maintaining safety compliance."
    },
    {
      question: "How does GEM ensure safety in trampoline park manufacturing?",
      answer: "As a trusted Trampoline Park Manufacturer, GEM follows strict international safety standards throughout the design and production process. Every trampoline system includes safety enclosures, soft padding, and non-slip surfaces to minimize risks and ensure a secure jumping experience for all age groups."
    }
  ];

  const whyChooseFeatures = [
    {
      id: 0,
      title: "Creative Design Excellence",
      description: "At GEM, a global Indoor Playground Manufacturer and Trampoline Park Manufacturer, we specialize in creating imaginative, safe, and functional entertainment spaces. Our expert team of designers, engineers, and architects brings each concept to life through customized 3D layouts and detailed design planning. Every playground project is tailored to your space – from interactive play zones to dynamic lighting, music, and electronic games. As a trusted commercial playground equipment manufacturer, GEM ensures every design maximizes engagement and enhances the visitor experience."
    },
    {
      id: 1,
      title: "High-Quality and Safety Standards",
      description: "As a professional Indoor Playground Manufacturer, quality and safety are our top priorities. We manufacture durable playground equipment using non-toxic, child-safe materials that comply with international safety guidelines. With galvanized coating options, our play structures are suitable for both indoor and outdoor use. Whether you're developing a family entertainment center or a trampoline park, GEM guarantees unmatched quality setting us apart among top playground manufacturers worldwide."
    },
    {
      id: 2,
      title: "Customized Concepts for Every Project",
      description: "Every entertainment project is unique, and at GEM, your trusted indoor playground equipment supplier, we design and manufacture fully customized play solutions that match your brand identity. You can choose from various colors, styles, and themes to create an indoor play area that aligns with your business concept. From compact play corners to large-scale amusement centers, our team ensures your vision becomes a functional, visually stunning reality."
    },
    {
      id: 3,
      title: "Innovation and Smart Technology",
      description: "GEM is not just an Indoor Playground Manufacturer but also a forward-thinking Trampoline Park Manufacturer that integrates advanced technology into play systems. Our R&D engineers develop interactive and electronic play modules that merge traditional fun with modern engagement. These smart play systems help businesses manage their spaces efficiently while offering data-driven insights into visitor preferences keeping your venue ahead of competitors in the global playground industry."
    },
    {
      id: 4,
      title: "International Certifications & Compliance",
      description: "All GEM products are manufactured following international ASTM and EN standards (EN 1176 and EN 1177). As a leading Indoor Playground Manufacturer and Trampoline Park Manufacturer, we ensure our products are non-toxic, fire-resistant, and anti-climb certified. Every piece of playground equipment undergoes strict quality checks to guarantee long-term performance, reliability, and child safety making GEM a trusted name among commercial playground equipment manufacturers globally."
    }
  ];

  const toggleExpand = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="HomePage" >
      <Helmet>
        <title>Best Indoor Playground Equipment Manufacturer in Jordan</title>
        <meta
          name="description"
          content="Gemplay: global manufacturer of indoor playgrounds, soft play, trampoline parks, ninja courses & FEC equipment. Top-quality design and installation worldwide."
        />

            {/* Open Graph Meta */}
            <meta property="og:title" content="Best Indoor Playground Equipment Manufacturer in Jordan" />
            <meta
              property="og:description"
              content="Gemplay: global manufacturer of indoor playgrounds, soft play, trampoline parks, ninja courses & FEC equipment. Top-quality design and installation worldwide."
            />
            <meta property="og:image" content="https://gemplay.com.jo/gemIcon.jpg" />
              <meta property="og:image:width" content="1200" />
              <meta property="og:image:height" content="630" />
              <meta property="og:url" content="https://gemplay.com.jo/" />
              <meta property="og:type" content="website" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image" content="https://gemplay.com.jo/gemIcon.jpg" />

            
      </Helmet>
      <Header />
      <Dashboard title={title} imageUrl={homeImage} description={description} />
      <section className="product-section" >
        <div>
          <WhatsappButton altText="Chat with us on WhatsApp" iconSize={70} />
          {/* <Link
            to="/getquotations"
            style={{ textDecoration: "none", color: "inherit" }}
          > */}
            <h1>Products</h1>
            <div className="icon-container" onClick={handleTap} onTouchStart={handleTap} >
              <img
                src={plusicon}
                alt="soft play"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button" onClick={handleTap} onTouchStart={handleTap} >Get Quotation</button>
            </div>
          {/* </Link> */}
        </div>
        <div className="product-container" >
          <div className="product-row">
            <div className="product">
              <Link
                to="/TrampolinePark"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={trampoline}
                  alt="Indoor Playground Manufacturer_TRAMPOLINE PARK "
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Trampoline Park</p>
              </Link>
            </div>
            <div className="product">
              <Link
                to="/IndoorPlayground"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={playground}
                  alt=" Indoor Playground Manufacturer_Indoor playground "
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Indoor Playground</p>
              </Link>
            </div>
            <div className="product">
              <Link
                to="/Interactivegames"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={interactiveGame}
                  alt="Indoor playground manufacturer_ interactive games "
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Interactive Games</p>
              </Link>
            </div>
          </div>
          <div className="product-row">
            <div className="product">
              <Link
                to="/Climbingwall"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={ClimbingWall}
                  alt="    Indoor Playground Manufacturer_ climbing wall"
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Climbing Wall</p>
              </Link>
            </div>
            <div className="product">
              <Link
                to="/NinjaPark"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={ninjapark}
                  alt="  Indoor Playground Manufacturer_ninja park"
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Ninja Park</p>
              </Link>
            </div>
            <div className="product">
              <Link
                to="/EntranceSoftware"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  src={entrancesoftware}
                  alt=" Indoor Playground Manufacturer_entrance software"
                  className="product-image"
                  style={{ cursor: "pointer" }}
                />
                <p>Entrance Software</p>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="Projects-section">
        <img
          src={bgframe}
          alt="indoor play equipment commercial"
          className="Projects-bgframe"
        />
        <div
          className="grid-container"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="image-container">
            <img
              src={image1}
              alt="playground equipment company"
              className="Projects-image"
              data-aos="fade-right"
              data-aos-duration="2500"
            />
            <img
              src={image2}
              alt="soft play"
              className="Projects-image"
              data-aos="fade-left"
              data-aos-duration="2500"
            />
            <img
              src={image3}
              alt="playgrounds and parks"
              className="Projects-image"
              data-aos="fade-up-right"
              data-aos-duration="2500"
            />
            <img
              src={image4}
              alt="indoor playground with slide"
              className="Projects-image"
              data-aos="fade-up-left"
              data-aos-duration="2500"
            />
          </div>
        </div>
        <div
          className="Projects-header"
          data-aos="zoom-in-up"
          data-aos-duration="2500"
        >
          <h1>Projects by Leading Indoor Playground Manufacturer</h1>
          <p className="intro-text">
            Thinking about starting a new entertainment venue project? You're in the right place!
          </p>
          <p className="details-text">
            GEM, one of the leading Indoor Playground Equipment Manufacturers, creates fully customized projects from 
            start to finish designed to fit spaces like shopping malls, airports, restaurants, and family entertainment centers.
          </p>
          <p className="details-text">
            Safety is always our top priority. Our play center equipment is made with soft padding, rounded edges, 
            and non-toxic materials that meet all industry safety standards. Every product is tested and certified to
            ensure top quality and protection  giving you complete peace of mind while your guests enjoy a safe and fun
            play experience.
          </p>
          <a href="/Projects" className="see-more">
            See More
          </a>
        </div>
      </section>

      <section className="why-choose-gem">
        <div className="why-choose-container">
          <h2 className="why-choose-title">
            Why Choose GEM – Leading Indoor Playground Manufacturer & Trampoline Park Manufacturer
          </h2>
          
          <div className="features-grid">
            {whyChooseFeatures.map((feature, index) => (
              <div 
                key={index} 
                data-aos="fade-up" 
                data-aos-duration="2000"
                data-aos-once="true"
              >
                <h3 className="feature-title">{feature.title}</h3>
                <p className={`feature-description ${expandedCards[index] ? "show-full" : ""}`}>
                  {feature.description}
                </p>
                <button 
                  className="read-more-btn"
                  onClick={() => toggleExpand(index)}
                  type="button"
                >
                  {expandedCards[index] ? "Read Less" : "Read More"}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="services-container">
        <h1 className="services-title">Services</h1>
        <div className="services-grid">
          <div className="services-column">
            <div className="service-card">
              <img
                src={OnSiteIcon}
                alt="trampoline park with soft play"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">On-Site Installation</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>

            <div className="service-card">
              <img
                src={QualityControlIcon}
                alt="playground equipment suppliers"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">Quality Control</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>

            <div className="service-card">
              <img
                src={SupportIcon}
                alt="playground equipment catalog"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">Support & Maintenance</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>
          </div>

          <div className="image-mark">
            <img
              src={GroupLayer}
              alt="Indoor Playground Manufacturer_SERVICE"
              className="group-layer"
            />
          </div>

          <div className="services-column-right">
            <div className="service-card">
              <img
                src={InHouseIcon}
                alt="highest quality trampoline"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">In-House Production</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>

            <div className="service-card">
              <img
                src={BespokeIcon}
                alt="indoor playground with slide"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">Bespoke Design</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>

            <div className="service-card">
              <img
                src={AllDetailsIcon}
                alt="indoor commercial playground"
                className="service-icon"
              />
              <Link
                to="/Roadmap"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div>
                  <h3 className="service-title">All Details</h3>
                  <p className="service-description"></p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <CompaniesCard />

      <section className="faq-section">
        <div className="faq-container">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          
          <div className="faq-list">
            {faqData.map((faq, index) => (
              <div 
                key={index} 
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <button
                  className="faq-question"
                  onClick={() => toggleExpand(`faq-${index}`)}
                  type="button"
                >
                  <span>{faq.question}</span>
                  <span className="faq-icon">
                    {expandedCards[`faq-${index}`] ? '−' : '+'}
                  </span>
                </button>
                <div className={`faq-answer ${expandedCards[`faq-${index}`] ? 'show' : ''}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Homepage;